export default __webpack_public_path__ + "static/media/arrow_down.855267f1.svg";